export default __webpack_public_path__ + "static/media/ic-telegram.84882619.svg";